import { render, staticRenderFns } from "./SpacerBlock.vue?vue&type=template&id=07415bed&"
import script from "./SpacerBlock.vue?vue&type=script&lang=js&"
export * from "./SpacerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports